import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';

export interface WorldApiConfig {
  baseURL: string;
  apiKey?: string;
  organizationId?: string;
  accessToken?: string;
}

let config: WorldApiConfig = {
  baseURL: 'http://localhost:8043'
};

export const setWorldApiConfig = (newConfig: Partial<WorldApiConfig>) => {
  config = { ...config, ...newConfig };
};

export const getWorldApiConfig = (): WorldApiConfig => config;

export const customInstance = <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig
): Promise<T> => {
  const source = axios.CancelToken.source();
  
  const instance: AxiosInstance = axios.create({
    baseURL: getWorldApiConfig().baseURL,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  // Add auth headers if available
  instance.interceptors.request.use((config) => {
    const apiConfig = getWorldApiConfig();
    
    if (apiConfig.accessToken) {
      config.headers.Authorization = `Bearer ${apiConfig.accessToken}`;
    } else if (apiConfig.apiKey) {
      config.headers['X-API-Key'] = apiConfig.apiKey;
    }
    
    if (apiConfig.organizationId) {
      config.headers['X-Organization-Id'] = apiConfig.organizationId;
    }
    
    return config;
  });

  // Add response interceptor for error handling
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        // Handle unauthorized
        console.error('Unauthorized: Token may be expired');
      }
      return Promise.reject(error);
    }
  );

  const promise = instance({
    ...config,
    ...options,
    cancelToken: source.token,
  }).then(({ data }) => data);

  // @ts-ignore
  promise.cancel = () => {
    source.cancel('Query was cancelled');
  };

  return promise;
};